import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import DropdownSelect, { SelectType } from '../../components/DropdownSelect';
import { useToast } from '../../controller/ToastController';
import StoreController, {
  CurrentStoreContext,
  DeliveryType,
  deliverySaleType,
} from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import { getNumberToString } from '../../utils/util';

const preparationTimeList: SelectType[] = [];
const deliveryTimeList: SelectType[] = [];
for (let i = 15; i <= 90; i += 5) {
  preparationTimeList.push({
    key: i,
    value: i,
    name: `${i}분`,
    label: `${i}분`,
  });
}

for (let i = 5; i <= 180; i += 5) {
  deliveryTimeList.push({
    key: i,
    value: i,
    name: `${i}분`,
    label: `${i}분`,
  });
}

interface ToggleProps {
  value: boolean;
  setValue: (value: boolean) => void;
}

const Toggle = ({ value, setValue }: ToggleProps) => {
  return (
    <Style>
      <div className={`toggle ${value && 'active'}`}></div>
    </Style>
  );
};

const StoreDelivery = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [preparationTime, setPreparationTime] = useState<SelectType>({
    key: 15,
    value: 15,
    name: '15분',
    label: '15분',
  });
  const [deliveryTime, setDeliveryTime] = useState<SelectType>({
    key: 5,
    value: 5,
    name: '5분',
    label: '5분',
  });
  const [callType, setCallType] = useState<number>(0); // 0: 선택 1: 고정
  const [deliveryType, setDeliveryType] = useState<number>(1); // 0: 연동 1: 직접배달
  const [minOrderPrice, setMinOrderPrice] = useState<string>('');
  const [baseDeliveryPrice, setBaseDeliveryPrice] = useState<string>('');

  const [saleList, setSaleList] = useState<deliverySaleType[]>([]);
  const [saleMinimumPrice, setSaleMinimumPrice] = useState<string>('');
  const [saleDiscount, setSaleDiscount] = useState<string>('');

  const [isHolidayDiscount, setIsHolidayDiscount] = useState<boolean>(false);
  const [holidayDiscount, setHolidayDiscount] = useState<string>('');
  const [isWeatherDiscount, setIsWeatherDiscount] = useState<boolean>(false);
  const [weatherDiscount, setWeatherDiscount] = useState<string>('');

  const [visiblePreparationTimeGuide, setVisiblePreparationTimeGuide] = useState<boolean>(false);
  const [visibleDeliveryTypeGuide, setVisibleDeliveryTypeGuide] = useState<boolean>(false);
  const [visibleDeliveryTimeGuide, setVisibleDeliveryTimeGuide] = useState<boolean>(false);

  const onChangePreparationTime = (event: any) => {
    setPreparationTime(event);
  };
  const onChangeDeliveryTime = (event: any) => {
    setDeliveryTime(event);
  };
  const onChangeCallType = (value: number) => {
    if (deliveryType === 0) {
      setCallType(value);
    }
  };
  const onChangeMinOrderPrice = (event: any) => {
    setMinOrderPrice(getNumberToString(event.target.value));
  };
  const onChangeBaseDeliveryPrice = (event: any) => {
    setBaseDeliveryPrice(getNumberToString(event.target.value));
  };
  const onChangeSaleMinimumPrice = (event: any) => {
    setSaleMinimumPrice(getNumberToString(event.target.value));
  };
  const onChangesaleDiscount = (event: any) => {
    setSaleDiscount(getNumberToString(event.target.value));
  };

  const checkSalesOrderPrice = () => {
    let checkTemp = false;
    saleList.map((item) => {
      if (item.more_order_price === Number(saleMinimumPrice)) {
        checkTemp = true;
      }
    });
    return checkTemp;
  };

  const addSaleList = () => {
    if (saleMinimumPrice.length === 0) {
      showToast('주문 금액을 입력해주세요', 'error');
    } else if (checkSalesOrderPrice()) {
      showToast('이미 배달 할인이 적용된 주문금액이에요', 'error');
    } else if (Number(saleDiscount) > Number(baseDeliveryPrice)) {
      showToast('기본 배달 팁보다 높게 할인할 수 없어요', 'error');
    } else if (saleDiscount.length === 0) {
      showToast('할인 금액을 입력해주세요', 'error');
    } else {
      setSaleList([
        ...saleList,
        {
          more_order_price: Number(saleMinimumPrice),
          more_delivery_price: Number(saleDiscount),
        },
      ]);
      setSaleMinimumPrice('');
      setSaleDiscount('');
    }
  };

  const deleteSaleList = (index: number) => {
    saleList.splice(index, 1);
    setSaleList([...saleList]);
  };

  const PreparationTimeGuide = useMemo(() => {
    return (
      <div className={`guideBox ${visiblePreparationTimeGuide && 'active'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/img/deliveryGuide.png`}
          alt="준비완료시간선택 가이드 이미지"
          width={550}
          className="guideImage"
        />
      </div>
    );
  }, [visiblePreparationTimeGuide]);
  // const PreparationTimeGuide = useMemo(() => {
  //   return (
  //     <div className={`guideBox ${visiblePreparationTimeGuide && 'active'}`}>
  //       <img
  //         src={`${process.env.PUBLIC_URL}/img/delivery01.png`}
  //         alt="준비완료시간선택 가이드 이미지"
  //         width={550}
  //         className="guideImage"
  //       />
  //       <img
  //         src={`${process.env.PUBLIC_URL}/img/delivery03.png`}
  //         alt="준비완료시간선택 가이드 이미지"
  //         width={550}
  //         className="guideImage"
  //       />
  //     </div>
  //   );
  // }, [visiblePreparationTimeGuide]);
  const deliveryTypeGuide = useMemo(() => {
    return (
      <div className={`guideBox ${visibleDeliveryTypeGuide && 'active'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/img/delivery02.png`}
          alt="준비완료시간선택 가이드 이미지"
          width={550}
          className="guideImage"
        />
      </div>
    );
  }, [visibleDeliveryTypeGuide]);
  const deliveryTimeGuide = useMemo(() => {
    return (
      <div className={`guideBox ${visibleDeliveryTimeGuide && 'active'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/img/delivery03.png`}
          alt="준비완료시간선택 가이드 이미지"
          width={550}
          className="guideImage"
        />
      </div>
    );
  }, [visibleDeliveryTimeGuide]);

  // 필수 확인
  const checkRequired = () => {
    if (minOrderPrice.length > 0 && baseDeliveryPrice.length > 0) return true;
    return false;
  };

  // API 호출
  const getDeliveryData = async () => {
    try {
      const oRes: any = await StoreController.getDeliveryInfo(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log('getDeliveryInfo', oResponse);

        if (oResponse.data) {
          setMinOrderPrice(oResponse.data.delivery_manage.limit_order_price.toString());
          setBaseDeliveryPrice(oResponse.data.delivery_manage.base_delivery_price.toString());
          setDeliveryType(oResponse.data.delivery_manage.is_self_delivery);
          setCallType(oResponse.data.delivery_manage.delivery_call_type);
          setDeliveryTime({
            key: oResponse.data.delivery_manage.delivery_estimated_time,
            value: oResponse.data.delivery_manage.delivery_estimated_time,
            name: `${oResponse.data.delivery_manage.delivery_estimated_time}분`,
            label: `${oResponse.data.delivery_manage.delivery_estimated_time}분`,
          });
          setPreparationTime({
            key: oResponse.data.delivery_manage.delivery_prepare_time,
            value: oResponse.data.delivery_manage.delivery_prepare_time,
            name: `${oResponse.data.delivery_manage.delivery_prepare_time}분`,
            label: `${oResponse.data.delivery_manage.delivery_prepare_time}분`,
          });
          let priceList: deliverySaleType[] = [];
          oResponse.data.delivery_price.map((item: deliverySaleType) => {
            priceList.push({
              more_delivery_price:
                oResponse.data.delivery_manage.base_delivery_price - item.more_delivery_price,
              more_order_price: item.more_order_price,
            });
          });
          setSaleList(priceList);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const setDeliveryData = async () => {
    try {
      if (checkRequired()) {
        const deliveryManage: DeliveryType = {
          limit_order_price: parseInt(minOrderPrice),
          max_delivery_distance: '0',
          base_delivery_price: parseInt(baseDeliveryPrice),
          base_delivery_distance: '0',
          surcharge_delivery_distance: 0,
          surcharge_delivery_price: 0,
          is_self_delivery: deliveryType,
          delivery_call_type: callType,
          delivery_estimated_time:
            deliveryType === 0 ? preparationTime.value + deliveryTime.value : deliveryTime.value,
          delivery_prepare_time: preparationTime.value,
        };
        let priceList: deliverySaleType[] = [];
        saleList.map((item: deliverySaleType) => {
          priceList.push({
            more_delivery_price: Number(baseDeliveryPrice) - item.more_delivery_price,
            more_order_price: item.more_order_price,
          });
        });
        const oRes: any = await StoreController.setDeliveryInfo(
          currentStore.value,
          deliveryManage,
          priceList,
        );

        if (oRes && oRes.data) {
          const oResponse: any = oRes.data;
          console.log('editStore', oResponse);
          if (oResponse.ok) {
            showToast('배달 정보를 변경했어요');
          }
        }
      } else {
        showToast('필수 정보를 입력해주세요', 'error');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getDeliveryData();
  }, [currentStore]);

  return (
    <Style>
      <div className="contentContainer">
        {/* <div className="inputText">
          <div className="title guide">
            <h4>직접배달 사용 유무</h4>
            <h5>(필수)</h5>
            <img
              onClick={() => setVisibleDeliveryTypeGuide(!visibleDeliveryTypeGuide)}
              src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
              alt="가이드 아이콘"
            />
            {visibleDeliveryTypeGuide && deliveryTypeGuide}
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${deliveryType === 1 && 'active'}`}
              onClick={() => setDeliveryType(1)}>
              직접배달 사용함
            </div>
            <div
              className={`selectBox right ${deliveryType === 0 && 'active'}`}
              onClick={() =>
                // setDeliveryType(0)
                showToast('준비중이에요', 'error')
              }>
              직접배달 안함
            </div>
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="주의사항 아이콘" />
            <p>직접배달은 선택하시면 주문접수 시 배달호출 시간 설정에서 직접호출도 보여집니다</p>
          </div>
        </div> */}
        {/* <div className="inputText">
          <div className="title">
            <h4>배달 기사 호출 방법</h4>
            <h5>(필수)</h5>
          </div>
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${
                deliveryType === 1 ? 'disabled' : callType === 0 && 'active'
              }`}
              onClick={() => onChangeCallType(0)}>
              매번 시간 선택하기
            </div>
            <div
              className={`selectBox right ${
                deliveryType === 1 ? 'disabled' : callType === 1 && 'active'
              }`}
              onClick={() => onChangeCallType(1)}>
              시간 고정
            </div>
          </div>
        </div> */}
        <div className="inputText">
          <div className="title guide">
            {/* <h4>준비 완료 시간 선택</h4> */}
            <h4>배달도착 예상시간</h4>
            <h5>(필수)</h5>

            <img
              // onClick={() => setVisiblePreparationTimeGuide(!visiblePreparationTimeGuide)}
              onMouseEnter={() => setVisiblePreparationTimeGuide(true)}
              onMouseLeave={() => setVisiblePreparationTimeGuide(false)}
              src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
              alt="가이드 아이콘"
            />
            {visiblePreparationTimeGuide && PreparationTimeGuide}
          </div>
          <div className="inputWrap">
            <DropdownSelect
              options={deliveryTimeList}
              defaultValue={deliveryTime}
              onChangeValue={onChangeDeliveryTime}
            />
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="주의사항 아이콘" />
            {/* <p>주문 접수 시 설정한 시간에 맞춰서 배달기사가 호출됩니다</p> */}
            <p>고객님께 알려드릴 배달도착 예상시간입니다. 호텔 객실 기기, 주문 포스에 노출됩니다</p>
          </div>
        </div>
        {/* <div className="inputText">
          <div className="title guide">
            <h4>배달예상 소요시간</h4>
            <h5>(필수)</h5>
          </div>
          <div className="inputWrap">
            <DropdownSelect
              options={deliveryTimeList}
              defaultValue={deliveryTime}
              onChangeValue={onChangeDeliveryTime}
              disabled={deliveryType === 1}
            />
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="주의사항 아이콘" />
            <p>호텔별로 배달시간이 다를 수 있으니, 대략적인 시간을 선택해주세요</p>
          </div>
        </div> */}
        {/* <div className="inputText">
          <div className="title guide">
            <h4>배달예상 도착시간</h4>
            <img
              onClick={() => setVisibleDeliveryTimeGuide(!visibleDeliveryTimeGuide)}
              src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
              alt="가이드 아이콘"
            />
            {visibleDeliveryTimeGuide && deliveryTimeGuide}
          </div>
          <div className="inputWrap">
            <div className="selector">
              {`${
                deliveryType === 0
                  ? preparationTime.value + deliveryTime.value
                  : preparationTime.value
              }`}
              분
            </div>
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="주의사항 아이콘" />
            <p>준비완료시간과 배달예상 소요시간을 더한 시간입니다. </p>
          </div>
        </div> */}
      </div>
      <div className="contentContainer">
        <div className="inputText">
          <div className="title">
            <h4>최소 주문 금액</h4>
            <h5>(필수)</h5>
          </div>
          <div className="inputWrap">
            <div className="unit">원</div>
            <input
              type="text"
              value={minOrderPrice}
              placeholder="0"
              onChange={onChangeMinOrderPrice}
            />
          </div>
        </div>
        <div className="inputText">
          <div className="title">
            <h4>기본 배달 팁</h4>
            <h5>(필수)</h5>
          </div>
          <div className="inputWrap">
            <div className="unit">원</div>
            <input
              type="text"
              value={baseDeliveryPrice}
              placeholder="0"
              onChange={onChangeBaseDeliveryPrice}
            />
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="주의사항 아이콘" />
            <p>
              입력하지 않으면 배달팁이 부과되지 않으며, 배달 플랫폼 보다 높은 배달팁을 등록하면
              광고가 반려될 수 있습니다.
            </p>
          </div>
        </div>
      </div>
      <div className="contentContainer">
        <div className="inputText">
          <div className="title">
            <h4>주문금액 구간별 배달 할인</h4>
          </div>
          {saleList.length > 0 ? (
            <div className="additionalList">
              {saleList.map((item: deliverySaleType, index: number) => {
                return (
                  <div className="additionalItem" key={index}>
                    {item.more_order_price}원 이상일 때 {item.more_delivery_price}원 할인
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                      onClick={() => deleteSaleList(index)}
                      alt="ic"
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="additionalList">
              <div className="noneList">할인 조건을 추가해주세요</div>
            </div>
          )}
        </div>
        <div className="inputText">
          <div className="title">
            <h5 className="subtitle">주문금액 구간별 배달 할인 추가</h5>
          </div>
          <div className="row between">
            <div className="row gap">
              <div className="inputWrap">
                <div className="unit">원</div>
                <input
                  type="text"
                  value={saleMinimumPrice}
                  placeholder="0"
                  onChange={onChangeSaleMinimumPrice}
                />
              </div>
              <h4>이상일 때</h4>
            </div>
            <div className="row gap">
              <div className="inputWrap">
                <div className="unit">원</div>
                <input
                  type="text"
                  value={saleDiscount}
                  placeholder="0"
                  onChange={onChangesaleDiscount}
                />
              </div>
              <h4>할인됩니다</h4>
            </div>
          </div>
          <button className="addButton" onClick={addSaleList}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
            <h5>추가하기</h5>
          </button>
        </div>
        <button
          className={`submitButton ${!checkRequired() && 'inactive'}`}
          onClick={setDeliveryData}>
          배달정보 등록
        </button>
      </div>
    </Style>
  );
};

export default StoreDelivery;

const Style = styled.div`
  /* contentContainer */
  .contentContainer:nth-child(1) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0;
  }
  .contentContainer:nth-child(3) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  /* inputText */
  .inputText {
    margin-bottom: 40px;
    input {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }

    .row.between {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      .row.gap {
        display: flex;
        align-items: center;
        gap: 8px;
        h4 {
          color: #979797;
          font-weight: 400;
          white-space: nowrap;
        }
      }
    }
  }

  input::placeholder,
  textarea::placeholder {
    color: #cecece;
  }

  /* title */
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 6px;

    h5 {
      color: #40977f;
      font-weight: 500;
    }
    h4 {
      color: #555555;
    }
    h5.subtitle {
      color: #555555;
    }
  }
  .title.guide {
    width: 100%;
    position: relative;
  }

  /* inputWrap */
  .inputWrap {
    position: relative;
    .unit {
      position: absolute;
      font-size: 16px;
      line-height: 22px;
      color: #a7a7a7;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
    }
  }
  .warningSign {
    margin-top: 8px;
  }

  /* selectBoxWrap */
  .selectBoxWrap {
    display: flex;
    align-items: center;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #fff;
      font-size: 16px;
      color: #979797;
      padding: 12px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
    .selectBox.disabled {
      border: 1px solid #e5e5e5;
      background: #e5e5e5;
      color: #979797;
    }
  }

  .selector {
    position: relative;
    padding: 8px 10px 8px 20px;
    font-size: 14px;
    line-height: 20px;
    color: #979797;
    border: 1px solid #cecece;
    border-radius: 5px;
    cursor: pointer;
  }

  /* guideBox */
  .guideBox {
    position: absolute;
    top: 5px;
    left: 156px;
    z-index: 2;
  }
  .guideBox.active {
    animation: fadeIn 0.2s ease-in-out forwards;
  }

  .additionalList {
    border: 1px solid #cecece;
    border-radius: 5px;
    .additionalItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 20px;
      border-bottom: 1px solid #f7f7f7;
      border-radius: 5px;
      color: #555555;
    }

    .noneList {
      text-align: left;
      padding: 17.5px 30px;
      color: #979797;
    }
  }

  .addButton {
    margin-top: 16px;
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 20px;

    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  @media (max-width: 900px) {
    .guideBox {
      top: 30px;
      left: 0px;
    }
  }
  @media (max-width: 600px) {
    .guideImage {
      width: 300px;
    }
  }
`;
